// apps/roleforge-app/src/lib/oto-ledger.ts
//
// RoleForge v2 Plan 2, Task 4 — the free-upgrade ledger copy, shared verbatim
// between the OTO decision card (OtoPage) and the delivery page's late
// re-offer card (AuditDashboardPage). One source so the two surfaces can
// never describe the same offer differently.
//
// Copy register: calm operator. No urgency, no countdowns.

export interface OtoLedgerRow {
  label: string;
  sub: string;
  amount: string;
}

export const OTO_LEDGER_ROWS: readonly OtoLedgerRow[] = [
  {
    label: 'Implementation course',
    sub: 'Build your Blueprint by hand in Claude Code, ChatGPT, or any AI tool — guided videos, step by step. Keep it forever.',
    amount: 'Free',
  },
  {
    label: '14-day VibeControl trial, ready when you are',
    sub: 'Standard plan. Starts only when you click Set it up in VibeControl.',
    amount: '$0 today',
  },
  {
    label: '2,500 credits of agent work',
    sub: 'Lands at activation. Your first two weeks of output, covered.',
    amount: 'Included',
  },
];
